import styled from "styled-components";

import { Checked } from "../../../../assets/svgs";

import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 12px;

  @media screen and (max-width: 768px) {
    gap: 12px;
  }
`;

export const MultiselectContainer = styled.div`
  margin-bottom: 27px;

  @media screen and (max-width: 768px) {
    margin-bottom: 0;
  }
`;

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const CheckboxInput = styled.input`
  display: none;
`;

export const StyledCheckbox = styled.input<{ isChecked: boolean }>`
  background: ${(props) => (props.checked ? Checked : theme.colors.blue900)};
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const CheckboxLabel = styled.span`
  margin-left: 5px;
  color: ${theme.colors.white};

  cursor: pointer;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const MultiselectTitle = styled.span`
  font-size: 12px;
`;

export const Wrapper = styled.div`
  font-family: ${theme.font.poppins};

  .label {
    position: absolute;
    top: -20px;
    left: 0;
  }
`;
